module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.inputType == 'radio') ? _c('el-radio-group', {
    attrs: {
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  }, _vm._l((_vm.filterData), function(item) {
    return _c('el-radio', {
      key: item.dictId,
      attrs: {
        "label": item.dictCode
      }
    }, [_vm._v(_vm._s(item.dictName))])
  }), 1) : _c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  }, _vm._l((_vm.filterData), function(item) {
    return _c('el-checkbox', {
      key: item.dictId,
      attrs: {
        "label": item.dictCode
      }
    }, [_vm._v(_vm._s(item.dictName))])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ce0a47d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/RadioCheckBox.vue
// module id = 1342
// module chunks = 5